import { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromHTML, ContentState } from "draft-js";
// @material-ui/core components
import {
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardContent,
  Grid,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// Karsten
import Api from "lib/api/httpRequestHelper";
import hexToRgb from "assets/theme/hex-to-rgb";

const useStyles = makeStyles((theme) => ({
  scrollbarClass: {
    overflowY: "auto",
    marginRight: 10,
    padding: 0,
    "&::-webkit-scrollbar": {
      width: "0.45rem",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "1.5rem",
      borderRadius: 4,
      backgroundColor: `rgba(${hexToRgb(theme.palette.black.main)}, 0.2)`,
      outline: `rgba(${hexToRgb(theme.palette.black.main)}, 0.7)`,
    },
  },
  root: {
    "& > *,& > ul > li > *": {
      textAlign: "justify",
      textJustify: "inter-word",
      fontSize: 14,
      fontFamily: "Times New Roman, Times, serif",
    },
    "& > strong": {
      display: "inline-block",
    },
  },
  title: {
    display: "flex",
    justifyContent: "center",
  },
}));

function DialogLastRelease({ releases, open, setOpenDialog, setReleases }) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleReleaseAccept = async (release) => {
    const today = new Date().toISOString().slice(0, 10);

    const newReleaseList = releases?.filter(
      (item) =>
        item?.IdReleaseSistemaProduto !== release?.IdReleaseSistemaProduto
    );

    const newObject = {
      Ativo: release?.Ativo,
      DataInclusao: release?.DataInclusao,
      DataInclusaoFormat: release?.DataInclusaoFormat,
      DataVisualizacaoFormat: release?.DataVisualizacaoFormat,
      Descricao: release?.Descricao,
      IdReleaseSistemaProduto: release?.IdReleaseSistemaProduto,
      IdSistemaIntegracao: release?.IdSistemaIntegracao,
      IdUsuarioInclusao: release?.IdUsuarioInclusao,
      Titulo: release?.Titulo,
      DataVisualizacao: today,
    };
    newReleaseList?.unshift(newObject);

    setReleases(newReleaseList);

    await Api.put(
      "edit-release-product",
      "conteudo",
      {
        idReleaseSistemaProduto: release?.IdReleaseSistemaProduto?.toString(),
        idPessoaLoja: release?.Id?.toString(),
        titulo: release?.Titulo,
        descricao: release?.Descricao,
        versaoSistema: release?.VersaoSistema,
        idSistemaIntegracao: release?.IdSistemaIntegracao,
        dataVisualizacao: today,
      },
      true
    )
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);

    const filterRelease = releases?.filter(
      (item) => item?.IdReleaseSistemaProduto === panel
    );
    if (filterRelease[0]?.DataVisualizacao === undefined && !expanded) {
      handleReleaseAccept(filterRelease[0]);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpenDialog(false)}
      maxWidth="lg"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className={classes.title}>
        <Typography variant="h3" component="h3">
          Últimas atualizações do Portal
        </Typography>
      </DialogTitle>
      <DialogContent
        classes={{
          root: classes.scrollbarClass,
        }}
        style={{
          padding: "0 1.5rem",
          marginTop: "0.5rem",
        }}
      >
        <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
          <div className={classes.root}>
            {releases?.map((item) => {
              let releaseDescription = "";

              const html = item?.Descricao;
              const blocksFromHTML = convertFromHTML(html);

              const customContentStateConverter = (contentState) => {
                const newBlockMap = contentState.getBlockMap().map((block) => {
                  const entityKey = block.getEntityAt(0);
                  if (entityKey !== null) {
                    const entityBlock = contentState.getEntity(entityKey);
                    const entityType = entityBlock.getType();
                    switch (entityType) {
                      case "IMAGE": {
                        const newBlock = block.merge({
                          type: "atomic",
                          text: "img",
                        });
                        return newBlock;
                      }
                      default:
                        return block;
                    }
                  }
                  return block;
                });
                const newContentState = contentState.set(
                  "blockMap",
                  newBlockMap
                );
                return newContentState;
              };

              releaseDescription = EditorState.createWithContent(
                customContentStateConverter(
                  ContentState.createFromBlockArray(
                    blocksFromHTML.contentBlocks,
                    blocksFromHTML.entityMap
                  )
                )
              );

              return (
                <Accordion
                  key={item?.IdReleaseSistemaProduto}
                  expanded={expanded === item?.IdReleaseSistemaProduto}
                  onChange={handleChange(item?.IdReleaseSistemaProduto)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={classes.heading}>
                      {item?.Titulo}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <CardContent>
                      <Grid
                        container
                        alignItems="center"
                        display="flex"
                        style={{ marginBottom: "1rem" }}
                      >
                        <Grid item xs={3}>
                          <Typography
                            variant="h5"
                            component="h5"
                            style={{
                              marginLeft: "-1rem",
                              fontSize: "0.75rem",
                              color: "#696969",
                            }}
                          >
                            Sistema:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {item?.IdSistemaIntegracao}
                            </span>
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          hidden={item?.IdSistemaIntegracao === "PORTAL"}
                        >
                          <Typography
                            variant="h5"
                            component="h5"
                            style={{
                              marginLeft: "-1rem",
                              fontSize: "0.75rem",
                              color: "#696969",
                            }}
                          >
                            Versão:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {item?.versaoSistema}
                            </span>
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        alignItems="center"
                        display="flex"
                        style={{ marginBottom: "1rem" }}
                      >
                        <Editor
                          editorState={releaseDescription}
                          readOnly={true}
                          toolbar={{ options: [] }}
                        />
                      </Grid>
                    </CardContent>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

export { DialogLastRelease };
